import clsx from 'clsx'
import { format } from 'date-fns'
import numberFormat from '@/utils/numberFormat'

export default function TradeHistory({
  price,
  size,
  side,
  ts,
  isNewest,
  priceFormat,
  sizeFormat
}) {
  const isPriceUp = side === 'BUY'
  const historyDate = new Date(ts)

  return (
    <div
      className={clsx('trade-history', {
        'flash-price-up': isNewest && isPriceUp,
        'flash-price-down': isNewest && !isPriceUp
      })}
    >
      <div
        className={clsx('price-cell align-left', {
          'is-down': !isPriceUp
        })}
      >
        {numberFormat(price, priceFormat)}
      </div>
      <div className="size-cell align-right">
        {numberFormat(size, sizeFormat)}
      </div>
      <div
        className="time-cell align-right"
        title={format(historyDate, 'yyyy-MM-dd HH:mm:ss')}
      >
        {format(historyDate, 'HH:mm:ss')}
      </div>
    </div>
  )
}
